import { PropsWithChildren } from 'react';

export const OrganisationAreaActions = ({ children }: PropsWithChildren) => {
  return <div>{children}</div>;
};
